import { createSelector } from 'reselect'

const chatState = (state) => state.chat

export const chatCredentialsSelectors = createSelector(chatState, (state) => state)
